import { render, staticRenderFns } from "./CreateStory.vue?vue&type=template&id=c4c32c0e"
import script from "./CreateStory.vue?vue&type=script&lang=js"
export * from "./CreateStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports